import meRoute from "../api/subscriptions/me.route";
import trialRoute from "../api/subscriptions/trial.route";
import { post } from "./lib";
import type { Org } from "src/models";

export const getMySubscription = () =>
  post<typeof meRoute, Org[]>("/api/subscriptions/me");

export const startTrial = () =>
  post<typeof trialRoute>("/api/subscriptions/trial");
